import TabsBox from './TabsBox';
export default TabsBox;


// WEBPACK FOOTER //
// ./src/components/TabsBox/index.js